
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class JoeyLogo extends Vue {
    @Prop({ default: false }) showFace!: boolean;
}
